import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "truncate",
  pure: true,
  standalone: false,
})
export class TruncatePipe implements PipeTransform {
  transform(input: string, length: number): string {
    return input.length > length ? input.slice(0, length - 3) + "..." : input;
  }
}
